type TDataValue =
  | string
  | boolean
  | number
  | string[][]
  | URLSearchParams
  | Record<string, string>;
type TData = Record<string, TDataValue>;

export const serializeTrackingProps = <Data extends TData = TData>(
  data: Data,
): Record<string, string> => {
  const keys = Object.keys(data);
  const serialized: Record<string, string> = {};

  keys.forEach(key => (serialized[key] = castToString(data[key])));

  return serialized;
};

const castToString = (value: TDataValue): string => {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'number') {
    return value.toString();
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }

  return new URLSearchParams(value).toString();
};
